import { GalleryData } from "@/lib/types";
import {
  OctaImg,
  RnalImg,
  AboutPic1,
  AboutPic2,
  Company1,
  Company2,
  Company3,
} from "@/assets/images/image";

export const galleryCol1: GalleryData[] = [
  {
    id: "1",
    src: "https://images.unsplash.com/photo-1574169208507-84376144848b?q=80&w=2599&auto=format&fit=crop",
    alt: "Tech Model 1",
  },
  {
    id: "2",
    src: "https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=2670&auto=format&fit=crop",
    alt: "Tech Model 2",
  },
  {
    id: "3",
    src: "https://images.unsplash.com/photo-1541701494587-cb58502866ab?q=80&w=2670&auto=format&fit=crop",
    alt: "Tech Model 3",
  },
  {
    id: "4",
    src: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop",
    alt: "Tech Model 4",
  },
];

export const galleryCol2: GalleryData[] = [
  {
    id: "1",
    src: "https://images.unsplash.com/photo-1618172193622-ae2d025f4032?q=80&w=2664&auto=format&fit=crop",
    alt: "Abstract Tech 1",
  },
  {
    id: "2",
    src: "https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?q=80&w=2667&auto=format&fit=crop",
    alt: "Abstract Tech 2",
  },
  {
    id: "3",
    src: "https://images.unsplash.com/photo-1558865869-c93f6f8482af?q=80&w=2681&auto=format&fit=crop",
    alt: "Abstract Tech 3",
  },
  {
    id: "4",
    src: "https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?q=80&w=2667&auto=format&fit=crop",
    alt: "Abstract Tech 4",
  },
];

export const galleryCol3: GalleryData[] = [
  {
    id: "1",
    src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
    alt: "Creative Studio 1",
  },
  {
    id: "2",
    src: "https://images.unsplash.com/photo-1550684376-efcbd6e3f031?q=80&w=2670&auto=format&fit=crop",
    alt: "Creative Studio 2",
  },
  {
    id: "3",
    src: "https://images.unsplash.com/photo-1501696461415-6bd6660c6742?q=80&w=2674&auto=format&fit=crop",
    alt: "Creative Studio 3",
  },
  {
    id: "4",
    src: "https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?q=80&w=2670&auto=format&fit=crop",
    alt: "Creative Studio 4",
  },
];

export const marqueeImages: GalleryData[] = [
  { id: "1", src: OctaImg, alt: "Octa" },
  { id: "2", src: RnalImg, alt: "Rnal" },
];

export const bannerMarquee: GalleryData[] = [
  { id: "1", src: Company1, alt: "Company1" },
  { id: "2", src: Company2, alt: "Company2" },
  { id: "3", src: Company3, alt: "Company3" },
  { id: "4", src: Company1, alt: "Company1" },
  { id: "5", src: Company2, alt: "Company2" },
  { id: "6", src: Company3, alt: "Company3" },
];

export const aboutGalleryData: GalleryData[] = [
  { id: "1", src: AboutPic1, alt: "Gallery Image 1" },
  { id: "2", src: AboutPic2, alt: "Gallery Image 2" },
  { id: "3", src: AboutPic1, alt: "Gallery Image 1" },
  { id: "4", src: AboutPic2, alt: "Gallery Image 2" },
  { id: "5", src: AboutPic1, alt: "Gallery Image 1" },
  { id: "6", src: AboutPic2, alt: "Gallery Image 2" },
];
